<template>
  <div class="table-search">
    <div
      class="table-search-item"
      v-for="(searchItem, searchIndex) in searchList"
      :key="searchIndex"
      >
      <component :is="'search-'+searchItem.type" :propKey="searchItem.prop" :items="searchItem.items" 
      :isAsync="searchItem.isAsync" :asyncItems="searchItem.asyncItems" :asyncOptions="searchItem.asyncOptions" 
      v-model="searchForm[searchItem.prop]" @search="search" :attrs="searchItem.attrs" /> 
    </div>
    <div class="table-search-item">
      <el-date-picker
        v-model="operateTime"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        :picker-options="pickerOptions"
        :clearable="false"
      />
    </div>
    <div class="table-search-item"><el-button @click="search" style="height:100%" type="primary">查询</el-button></div>
    <div class="table-search-item"><el-button @click="clear" style="height:100%">清空</el-button></div>
    <slot></slot>
  </div>
</template>

<script>
import SearchSelect from "@/components/prod/center/components/SearchSelect.vue";
import SearchInput from "@/components/prod/center/components/SearchInput.vue";
import { PROD_MODIFY_STATUS,PROD_MODIFY_OPERATE_SUB_TYPE } from '../../dictionary'
import {getDateStart, getDateEnd} from "@/pages/supplier/prod/log/util"
import { getStaffList } from '@servers/base/user/index.js';
import dayjs from 'dayjs';
export default {
  components: {
    SearchSelect,
    SearchInput,
  },
  data() {
    return {
      searchForm: {
        operateSubType: '',
        status: '',
        outerId:'',
        skuOuterId:'',
        staffIds:'',
        startTime: '',
        endTime: '',
      },
      searchList: [
        {prop: "operateSubType", type: 'select', attrs:{placeholder: '途径'}, items: PROD_MODIFY_OPERATE_SUB_TYPE},
        {prop: "status", type: 'select', attrs:{placeholder: '状态'}, items: PROD_MODIFY_STATUS },
        {prop: "outerId", type: 'input', attrs: {placeholder: '款式编码'}},
        {prop: "skuOuterId", type: 'input', attrs: {placeholder: '商品编码'}},
        {prop: "staffIds", type: 'select', attrs:{placeholder: '操作人', multiple:true }, asyncItems: [], isAsync:true, asyncOptions:{queryFn:this.getStaffIds,}},
      ],
      operateTime: [
        getDateStart(),
        getDateEnd(),
      ], 

    }
  },
  created() {
    const prodLogRetryFlag = sessionStorage.getItem('prodLogRetryFlag');
    if (prodLogRetryFlag) {
      const hasRetry = parseInt(prodLogRetryFlag);
      this.searchForm.hasRetry = isNaN(hasRetry) ? 0 : hasRetry;
    }
  },
  computed: {
    query() {
      let _query = {}
      this.searchForm = {
        ...this.searchForm,
        startTime: this.operateTime[0],
        endTime: this.operateTime[1]
      }
      for (const key in this.searchForm) {
        if (this.searchForm[key] !== '') {
          _query[key] = this.searchForm[key]
        }
      }
      return _query
    },
    pickerOptions() {
      const getTimeStampStart = () => {
        return dayjs().subtract(150, 'day').startOf('day')
      };

      const getTimeStampEnd = () => {
        return dayjs().endOf('day')
      };

      return {
        disabledDate(v) {
          return v.getTime() < getTimeStampStart() || v.getTime() > getTimeStampEnd()
        },
      };
    }

  },
  watch: {
    operateTime(newVal) {
      if(newVal == null) {
        this.operateTime = [getDateStart(),getDateEnd()]
      }
    }
  },
  methods: {
    method_getSearchForm() {
      return this.query
    },
    handleRetryFlagChanged(value) {
      sessionStorage.setItem('prodLogRetryFlag', value);
      this.search();
    },
    async getStaffIds(_params) {
      if(_params){
        _params.queryStaffName = _params?.queryText || '';
      }
      
      const res = await getStaffList(_params);
      if (res) {
        const index = this.searchList.findIndex(item => item.prop === 'staffIds');
        if(index !== -1) {
          let list = res.list;
          list.map(item=>{
            item.label = item.accountName;
            item.value = item.id; // 铺货日志里面存储的是id，商品新增存储的是accountId，所以这里需要用id查询
            return item;
          })
          this.$set(this.searchList[index], 'asyncItems', list || []);
        }
      }
    },

    search() {
      this.$emit('search', this.query)
    },
    clear() {
      this.operateTime = [
        getDateStart(),
        getDateEnd(),
      ], 
      this.searchForm = {
        shopId: '',
        outerId: '',
        startTime: '',
        endTime: ''
      }
      this.search();
    },
  }
}
</script>

<style lang="scss" scoped>
.table-search {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;

  &-item {
    margin-right: 8px;
    margin-bottom: 8px;
    line-height: 28px;
  }

}
</style>
